<template>
    <transition name="fade">
        <div>
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">Preview of Application</h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-info2 text-justify">
                                <i class="fas fa-info-circle mr-1 fs-15"></i> <b>Note:</b>Please review all the information you have entered for your loan application to make sure that everything is accurate and in order. Should you wish to edit anything, you may click the "Back" button and input the correct information.
                            </div>
                            <div class="details">
                                <div class=" details-title d-flex justify-content-between p-1">
                                    <h4>Borrower Information</h4>
                                </div>
                                <div class="details-body">
                                    <div class="row">
                                        <div class="col-sm-6 ">First Name:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> <span class="text-uppercase">{{user.fname}}</span> </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Middle Name:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> <span v-show="user.mname && user.mname !='NMN'" class="text-uppercase">{{user.mname}}</span> <span v-show="!user.mname || user.mname =='NMN'">-</span></label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Last Name:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> <span class="text-uppercase">{{user.lname}}</span></label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Suffix:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0">
                                                <span v-if="user.suffix_desc">{{user.suffix_desc}}</span>
                                                <span v-else>-</span>
                                            </label>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Birth Date:<span class="note">(MM/DD/YYYY)</span></div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 "> {{user.date_birth | MM/DD/YYYY}}</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="details">
                                <div class="details-title d-flex justify-content-between p-1">
                                    <h4>Business Details</h4>
                                </div>
                                <div class="details-body">
                                    <div class="row">
                                        <div class="col-sm-6 ">Type of Business:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 ">
                                                <span v-if="formLoan.bt_code=='BT2020002'">Partnership</span>
                                                <span v-if="formLoan.bt_code=='BT2020001'">Sole Proprietorship</span>
                                                <span v-if="formLoan.bt_code=='BT2020003'">Cooperative</span>
                                                <span v-if="formLoan.bt_code=='BT2020004'">Corporation</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">
                                            <span v-if="formLoan.bt_code=='BT2020002'">Partnership Name:</span>
                                            <span v-else-if="formLoan.bt_code=='BT2020004'">Corporation Name:</span>
                                            <span v-else>Business Name:</span>
                                        </div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 ">
                                                <span class="text-uppercase">{{formLoan.business_name}} </span>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 ">
                                            <span v-if="formLoan.bt_code=='BT2020002'">Partnership Date:</span>
                                            <span v-else-if="formLoan.bt_code=='BT2020004'">Incorporation Date:</span>
                                            <span v-else>Startup Date:</span>
                                            <span class="note">(MM/DD/YYYY)</span>
                                        </div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.start_date | MM/DD/YYYY}} </label>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12 mt-2 sub-title"><b>Business Address</b></div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 ">Province:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0  "> {{formLoan.province}} </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">City:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.city}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Barangay:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 "> {{formLoan.bname}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Street Name / Subdivision:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0"> {{formLoan.street_address}} </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">House No/Block & Lot/Building:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.bldg}} </label>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div class="details">
                                <div class="details-title d-flex justify-content-between p-1">
                                    <h4>Application Details</h4>
                                </div>
                                <div class="details-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-sm-6 ">Loan Amount:</div>
                                            <div class="col-sm-6">
                                                <label class="mb-0"> {{ formLoan.req_loan_amt | currency}} </label>

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 ">Loan Term: <span class="note">(in months)</span></div>
                                            <div class="col-sm-6">
                                                <label class="mb-0"> {{formLoan.req_loan_term}} </label>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-6 ">Grace Period: <span class="note">(in months)</span></div>
                                            <div class="col-sm-6">
                                                <label class="mb-0"> {{formLoan.grace_period}} </label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 ">Service Fee:</div>
                                            <div class="col-sm-6">
                                                <label class="mb-0"> {{formLoan.service_fee}} </label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 ">Interest Rate:</div>
                                            <div class="col-sm-6">
                                                <label class="mb-0">{{formLoan.interest_rate_pa}} p.a.</label>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-sm-12 mt-2 sub-title"><b>How do you want to receive your loan proceeds?</b></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Manner of Release:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 "> {{formLoan.manner_rel_desc}} </label>

                                        </div>
                                    </div>

                                    <div class="row" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                        <div class="col-sm-6 ">Bank Name:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 "> {{formLoan.bankname}}</label>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 ">Account Name:</div>
                                        <div class="col-sm-6 ">
                                            <label class="mb-0 ">
                                                <span class="text-uppercase">{{formLoan.acctname}} </span>
                                            </label>
                                        </div>

                                    </div>
                                    <div class="row" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                        <div class="col-sm-6 ">Account Number:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.acctno }} </label>
                                        </div>
                                    </div>

                                    <div class="row" v-if="formLoan.manner_rel =='GC' || formLoan.manner_rel =='PM'">
                                        <div class="col-sm-6 ">Registered Mobile Number:</div>
                                        <div class="col-sm-6">
                                            <label class="mb-0"> {{formLoan.acctno }} </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="card-footer">
                            <button class="btn btn-primary" @click="btnBack()"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modalPep" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">PEP and DOSRI Declaration</h5>
                        </div>
                        <div class="modal-body">

                            <div class="alert alert-success2" role="alert">
                                <p class="fs-15 bold mb-1">Definition of Terms:</p>
                                <p class="fs-14"><b><em>A. Politically Exposed Person (PEP)</em></b> - refers to an individual who is or has been entrusted with prominent public positions in the Philippines or in a foreign state, including heads of state or of government, senior politicians, senior national or local government, judicial or military officials, senior executives of government or state-owner or -controlled corporations and important political party officials.</p>
                                <p class="fs-14 ml-3">A.1. <b><em>Close Associates</em></b> - refer to persons who are widely and publicly known to maintain a particularly close relationship with the PEP, and include persons who are in a position to conduct substantial domestic and international financial transactions on behalf of the PEP.</p>
                                <p class="fs-14"><b><em>B. Directors, Officers, Stockholders and Related Interests (DOSRI)</em></b> - refers to the Directors, Officers and Stockholders of SB Corporation and their related interests.</p>
                            </div>

                            <alert-dismissible :category="'alert-danger2'" :toggle="$parent.submitting && $v.pep.$error">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible>

                            <div class="px-2">
                                <div v-for="(item,index) in pep">
                                    <p>{{item.seq + '. ' + item.content}}</p>
                                    <div class="row">
                                        <div class="col-6 text-center">
                                            <div class="icheck-primary d-inline">
                                                <input type="radio" :id="'y' + item.id" value="1" v-model="item.answer">
                                                <label :for="'y' + item.id" :class="{ 'errorRadio': $parent.submitting && $v.pep.$each[index].answer.$error }">Yes</label>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="icheck-primary d-inline">
                                                <input type="radio" :id="'n' + item.id" value="0" v-model="item.answer">
                                                <label :for="'n' + item.id" :class="{ 'errorRadio': $parent.submitting && $v.pep.$each[index].answer.$error }">No</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" @click="cancelModal">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="submitPep">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import {
        required,
    } from 'vuelidate/lib/validators';
    import AlertDismissible from "@vues/alerts/AlertDismissible.vue";
    export default {
        props: ['formLoan', 'user'],
        components: {
            AlertDismissible
        },
        data() {
            return {
                error: false,
                pep: [],
            }
        },
        validations: {
            pep: {
                $each: {
                    answer: {
                        required
                    },
                }
            },
        },
        created() {
            // this.getRefPepDostri();
        },
        methods: {
            getRefPepDostri() {
                this.$parent.payloading = true;
                axios.get('/api/v2-ref-pep-dostri')
                    .then(res => {
                        let data = res.data
                        this.pep = data.data;
                        $('#modalPep').modal('show');
                        this.$parent.payloading = false;
                    })
                    .catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            cancelModal() {
                this.pep = {};
                this.$parent.submitting = false;
                $('#modalPep').modal('hide');
            },
            btnBack() {
                this.$parent.updateStep(4, 'S4Q1');
            },
            submitPep() {
                const form = {
                    pep: this.pep,
                    application_id: this.formLoan.application_id
                }

                this.$parent.submitting = true;
                this.$v.pep.$touch();
                if (this.$v.pep.$invalid) {

                } else {
                    this.$parent.submitting = false;

                    this.$parent.payloading = true;
                    axios.post('/api/v2-rise-post-pep-dostri', form)
                        .then(res => {
                            this.$parent.payloading = false;
                            $('#modalPep').modal('hide');
                        }).catch(err => {
                            this.$parent.payloading = false;
                        })
                }
            },
            btnNext() {
                this.$parent.updateStep(4, 'S4Q3');
                // if (_.isEmpty(this.pep)) {
                //     this.getRefPepDostri();
                // } else {
                //     this.$parent.updateStep(5, 'S5Q1');
                // }
            },
        },
        computed: {},
        mounted() {
           
        }
    }
</script>



<style scoped>
    /* Added for Preview Details */
    .details>.details-title {
        background-color: #f1f5fb;
        margin-bottom: 0px;
    }

    .details>.details-title h4 {
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 0px;
    }

    .details>.details-title .btn-sm {
        padding: 1px 4px;
    }

    .details>.details-body .sub-title {
        font-size: 15px;
        /* color: #908fa2; */
        text-decoration: underline;
    }

    .details>.details-body {
        padding: 0px 10px 10px;
        font-size: 15px;
    }

    .note {
        font-size: 12px;
        color: #6c757d;
    }

    .details>.details-body .btn-group-sm>.btn,
    .details>.details-body .btn-sm {
        padding: 0px 8px;
        font-size: 13px;
    }

    .details>.details-body,
    .details>.details-body label {
        font-size: 15px;
        font-weight: 400;
    }


    @media(max-width:576px) {

        .details>.details-body,
        .details>.details-body label {
            font-size: 15px;
            font-weight: 600;
        }

        .details>.details-body .sub-title {
            font-size: 17px;
        }
    }

    .details>.details-body .form-control-sm,
    .details>.details-body .custom-select-sm {
        height: 1.5rem;
    }

    .details-body .custom-select-sm {
        font-size: 14px !important;
        padding-top: 0.04rem;
        padding-bottom: 0.1rem;
    }
</style>